'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const MobilePhoneIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="MobilePhoneIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        id="Mobile-Phone-2--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Mobile Phone 2 Streamline Icon: https://streamlinehq.com</desc>
        <path
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M18.5 19.5h-13"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M16.5 0.5h-9c-1.10457 0 -2 0.89543 -2 2v19c0 1.1046 0.89543 2 2 2h9c1.1046 0 2 -0.8954 2 -2v-19c0 -1.10457 -0.8954 -2 -2 -2Z"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#333333'}
          d="M12 21.75c-0.1381 0 -0.25 -0.1119 -0.25 -0.25s0.1119 -0.25 0.25 -0.25"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#333333'}
          d="M12 21.75c0.1381 0 0.25 -0.1119 0.25 -0.25s-0.1119 -0.25 -0.25 -0.25"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

MobilePhoneIcon.propTypes = {
  sx: PropTypes.object
}
